import { render, staticRenderFns } from "./Activity.vue?vue&type=template&id=0c71085e"
import script from "./Activity.vue?vue&type=script&lang=js"
export * from "./Activity.vue?vue&type=script&lang=js"
import style0 from "./Activity.vue?vue&type=style&index=0&id=0c71085e&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c71085e')) {
      api.createRecord('0c71085e', component.options)
    } else {
      api.reload('0c71085e', component.options)
    }
    module.hot.accept("./Activity.vue?vue&type=template&id=0c71085e", function () {
      api.rerender('0c71085e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/preview/Activity.vue"
export default component.exports